module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8e5e28b23ba596614a60d319d9c64165.svg";